import React from 'react';
import { List, Typography, Badge } from 'antd';

const { Text } = Typography;

const notifications = [
    {
        id: 1,
        title: 'New Assignment Available',
        description: 'A new math assignment has been posted.',
        isRead: false,
        time: '2 mins ago',
    },
    {
        id: 2,
        title: 'Profile Updated',
        description: 'Your profile details were successfully updated.',
        isRead: true,
        time: '1 hour ago',
    },
    {
        id: 3,
        title: 'Submission Reminder',
        description: 'Don’t forget to submit your history essay.',
        isRead: false,
        time: '5 hours ago',
    }, {
        id: 2,
        title: 'Profile Updated',
        description: 'Your profile details were successfully updated.',
        isRead: true,
        time: '1 hour ago',
    },
    {
        id: 3,
        title: 'Submission Reminder',
        description: 'Don’t forget to submit your history essay.',
        isRead: false,
        time: '5 hours ago',
    }, {
        id: 2,
        title: 'Profile Updated',
        description: 'Your profile details were successfully updated.',
        isRead: true,
        time: '1 hour ago',
    },
    {
        id: 3,
        title: 'Submission Reminder',
        description: 'Don’t forget to submit your history essay.',
        isRead: false,
        time: '5 hours ago',
    }, {
        id: 2,
        title: 'Profile Updated',
        description: 'Your profile details were successfully updated.',
        isRead: true,
        time: '1 hour ago',
    },
    {
        id: 3,
        title: 'Submission Reminder',
        description: 'Don’t forget to submit your history essay.',
        isRead: false,
        time: '5 hours ago',
    }, {
        id: 2,
        title: 'Profile Updated',
        description: 'Your profile details were successfully updated.',
        isRead: true,
        time: '1 hour ago',
    },
    {
        id: 3,
        title: 'Submission Reminder',
        description: 'Don’t forget to submit your history essay.',
        isRead: false,
        time: '5 hours ago',
    }, {
        id: 2,
        title: 'Profile Updated',
        description: 'Your profile details were successfully updated.',
        isRead: true,
        time: '1 hour ago',
    },
    {
        id: 3,
        title: 'Submission Reminder',
        description: 'Don’t forget to submit your history essay.',
        isRead: false,
        time: '5 hours ago',
    },
];

const NotificationList = () => {
    return (

        <List
            itemLayout="horizontal"
            dataSource={notifications}
            renderItem={(notification) => (
                <List.Item
                    className={`mb-3 p-3 rounded-lg ${notification.isRead ? 'bg-gray-100' : 'cursor-pointer bg-blue-50'
                        }`}
                >
                    <List.Item.Meta
                        title={
                            <div className="px-3 flex justify-between items-center">
                                <Text strong>{notification.title}</Text>
                                {!notification.isRead && (
                                    <Badge color="blue" className="relative right-4" />
                                )}
                            </div>
                        }
                        description={
                            <div className='px-3' >
                                <Text>{notification.description}</Text>
                                <br />
                                <Text type="secondary" className="text-sm">
                                    {notification.time}
                                </Text>
                            </div>
                        }
                    />
                </List.Item>
            )}
        />
    );
};

export default NotificationList;
